
// Libraries
var React = require('react');

// Styles
require('./RelatedStoriesTitle.scss');

class RelatedStoriesTitle extends React.Component {
	render() {
		return (
			<div className="RelatedStoriesTitle"><div className="RelatedStoriesTitle__inner">{this.props.heading}</div></div>
		)
	}
}

module.exports = RelatedStoriesTitle;


// WEBPACK FOOTER //
// ./src/components/RelatedStories/RelatedStoriesTitle.js